export default {
  add_items: 'Add items',
  remove_items: 'Remove items',
  place_order: 'Place order',
  pay_now: 'Pay now · {{amount}}',
  go_to_menu: 'Go to menu',
  secure_checkout: 'Secure checkout...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Payment failed',
      description: 'Please check your payment information and try again.',
    },
    internal_error: {
      title: 'Order unsuccessful 😔',
      description:
        'Unfortunately, there was an unexpected problem with your order, our tech team is already working on it 🛠️.',
    },
    order_blocked: {
      title: 'Order blocked',
      description:
        "We've detected suspicious activity coming from your account and blocked new orders until {{datetime}}. Reach out to support at {{supportEmail}} for details.",
      description_no_datetime:
        "We've detected suspicious activity coming from your account and blocked new orders. Reach out to support at {{supportEmail}} for details.",
    },
  },

  toasts: {
    input_errors_found: 'There are some issues with the your order info',
    select_payment_method: 'Choose a payment method to place your order.',
  },
};
